/* ============================================
   BABOT THEME — JavaScript
   ============================================ */

(function () {
  'use strict';

  /* --- Sticky header --- */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- FAQ Accordion --- */
  document.querySelectorAll('.faq__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq__item');
      const isOpen = item.classList.contains('open');

      // Close all
      document.querySelectorAll('.faq__item.open').forEach(el => {
        el.classList.remove('open');
        el.querySelector('.faq__btn').setAttribute('aria-expanded', 'false');
      });

      // Open clicked if it was closed
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* --- Scroll animations --- */
  const animEls = document.querySelectorAll('[data-anim]');
  if (animEls.length > 0) {
    if (window.Shopify && window.Shopify.designMode) {
      // In theme editor: skip animation, show everything immediately
      animEls.forEach(el => el.classList.add('visible'));
    } else {
      const io = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
      );
      animEls.forEach(el => io.observe(el));
    }
  }

  /* --- Disable form submissions in theme editor --- */
  if (window.Shopify && window.Shopify.designMode) {
    document.querySelectorAll('form').forEach(form => {
      form.addEventListener('submit', e => e.preventDefault());
    });
  }

  /* --- Sticky CTA --- */
  const stickyCta = document.getElementById('sticky-cta');
  const heroSection = document.querySelector('.hero');
  if (stickyCta && heroSection) {
    const heroObserver = new IntersectionObserver(
      ([entry]) => {
        stickyCta.classList.toggle('visible', !entry.isIntersecting);
        stickyCta.setAttribute('aria-hidden', String(entry.isIntersecting));
      },
      { threshold: 0.1 }
    );
    heroObserver.observe(heroSection);
  }

  /* --- Email popup --- */
  const popup = document.getElementById('email-popup');
  const popupClose = document.getElementById('email-popup-close');
  const popupSkip = document.getElementById('email-popup-skip');
  const POPUP_KEY = 'babot_popup_dismissed';

  function showPopup() {
    if (popup) popup.removeAttribute('hidden');
  }
  function dismissPopup() {
    if (popup) {
      popup.setAttribute('hidden', '');
      localStorage.setItem(POPUP_KEY, '1');
    }
  }
  if (popup && !localStorage.getItem(POPUP_KEY)) {
    const trigger = popup.dataset.trigger;
    const delay = parseInt(popup.dataset.delay || '10', 10) * 1000;
    if (trigger === 'delay') {
      setTimeout(showPopup, delay);
    } else {
      document.addEventListener('mouseleave', function onLeave(e) {
        if (e.clientY <= 0) {
          showPopup();
          document.removeEventListener('mouseleave', onLeave);
        }
      });
    }
  }
  if (popupClose) popupClose.addEventListener('click', dismissPopup);
  if (popupSkip)  popupSkip.addEventListener('click', dismissPopup);
  if (popup) {
    popup.addEventListener('click', function(e) {
      if (e.target === popup) dismissPopup();
    });
  }

  /* --- Smooth scroll for anchor links --- */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const id = a.getAttribute('href');
      if (id === '#') return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      const headerH = header ? header.offsetHeight : 0;
      const top = target.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

})();
